<template>
    <div class="xsc">
        <div class="top_banner">
            <div class="back_icon"
                 @click="goBack"></div>
            <img src="./img/share.png"
                 class="share"
                 @click="share"
                 alt=" " />
        </div>
        <div class="text">
            <div class="item">
                <div class="title"><span>课程特色</span></div>
                <div class="con">
                    <p><span>小升初</span>是学生学习生涯中的一个至关重要的转折点，学习习惯、学习方式、学习强度的巨大变化让学生猝不及防，而数学在其中更具有举足轻重的作用。</p>
                    <p>课程由长期从事中小学数学一线教学的杨老师亲自设计，以认识的自我转变为<span>切入点</span>，通过让学生提前熟悉七年级数学知识，培养学生独立思考和自主学习的能力，在进入初中后拥有明显的优势和信心，快速适应新的学习环境，有效消除他们对新学习内容的陌生感与畏惧心理。</p>
                </div>
            </div>
            <div class="item">
                <div class="title"><span>内容及特点</span></div>
                <div class="con">
                    <p>本课程聚焦七年级数学<span>“有理数”“整式”“一元一次方程”等核心内容。</span>引导学生深入理解和辨析定义、掌握运算规则及特点，通过实例让学生学会运算的技巧和规律。课程突出知识与生活中的联系，采用由浅入深、循序渐进的方式，配合大量生动的实例、直观和有趣的互动环节，使学生能够轻松理解和掌握这些新的知识领域，为他们即将开始的初中数学学习做好充分准备。</p>
                </div>
            </div>
        </div>
        <div class="btn">
            <router-link class="link"
                         to="/activity/xsc/list">开始学习课程</router-link>
        </div>
    </div>
</template>
<script>

export default {
    data () {
        return {

        }
    },
    created () {
        document.title = '小升初专题课';
    },
    methods: {
        goBack () {
            if (this.inApp) {
                this.appFunction("ys_finish", "", 1);
            } else {
                this.$router.go(-1);
            }
        },
        share () {
            let school_id = JSON.parse(localStorage.getItem('info')).units[0].school_id;
            let url = WAP_URL + "/qr/com_special?code_id=" + school_id + "&open_code=3694&hd_type=12"
            if (this.inApp) {
                this.appFunction("ys_share", `小升初专题课,点击开始学习小升初专题课,${url}`, 1);
            } else {
                let that = this
                let coptText = '小升初专题课，点击开始学习小升初专题课。链接：' + url
                this.copyVisible = true;
                layer.alert('将链接分享到对应的班级群，点击链接即可开始学习小升初专题课。', 'tea', function (index) {
                    that.copyText(coptText);
                    layer.close(index)
                }, '分享链接复制成功')
            }
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.xsc {
    min-height: 100vh;
    background-color: #6d94f7;
    padding-bottom: 200px / $ppr;
    .top_banner {
        height: 1260px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/banner1.png");
        position: relative;
        .back_icon {
            position: absolute;
            width: 56px / $ppr;
            height: 56px / $ppr;
            background-position: 50%;
            background-size: 56px / $ppr 56px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/back.png");
            cursor: pointer;
            top: 24px / $ppr;
            left: 24px / $ppr;
        }
        .share {
            position: absolute;
            right: 0;
            top: 285px / $ppr;
            width: 136px / $ppr;
            height: 64px / $ppr;
        }
    }
    .text {
        margin-top: -600px / $ppr;
        padding: 0 36px / $ppr;
        position: relative;
        .item {
            border-radius: 30px / $ppr;
            margin-top: 60px / $ppr;
            border: 2px / $ppr solid #fff;
            background-color: #d2eaff;
            background: -o-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: -ms-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: -moz-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            background: -webkit-linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);
            .title {
                text-align: center;
                padding: 24px / $ppr 0;
                span {
                    font-size: 42px / $ppr;
                    color: #212c4b;
                    font-weight: bold;
                    position: relative;
                    z-index: 9;
                    &:after {
                        content: "";
                        position: absolute;
                        z-index: -1;
                        bottom: 0;
                        left: 50%;
                        width: 100%;
                        height: 16px;
                        border-radius: 16px;
                        transform: translateX(-50%);
                        background-color: #9bcaff;
                        background: -o-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: -ms-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: -moz-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                        background: -webkit-linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                    }
                }
            }
            .con {
                background: #f1fcff;
                border-radius: 30px / $ppr;
                padding: 51px / $ppr 33px / $ppr 2px / $ppr;
                p {
                    text-indent: 2em;
                    font-size: 28px / $ppr;
                    line-height: 1.7;
                    margin-bottom: 40px / $ppr;
                    color: #060609;
                    span {
                        color: #4c66eb;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .btn {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 26px / $ppr 80px / $ppr;
        background: #fff;
        z-index: 99;
        .link {
            display: block;
            width: 100%;
            height: 88px / $ppr;
            line-height: 88px / $ppr;
            text-align: center;
            font-size: 34px / $ppr;
            color: #fff;
            border-radius: 88px / $ppr;
            background: url("./img/btn.png") no-repeat center;
            background-size: cover;
        }
    }
}
</style>
